import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import {
  MdLocalPhone,
  MdLocationPin,
  MdPublic,
  MdEmail,
  MdError,
} from 'react-icons/md';
import { IconType } from 'react-icons';

// tailwind class merge
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// static icon map for only used icons
const iconsMap: Record<string, IconType> = {
  MdLocalPhone,
  MdLocationPin,
  MdPublic,
  MdEmail,
};

export const loadIcon = async (iconName: string): Promise<IconType> => {
  return iconsMap[iconName] || MdError;
};

/**
 * Enhances an image URL by adding a quality parameter
 * @param src The source URL of the image
 * @param isMobile Boolean indicating if the device is mobile
 * @param desktopQuality Quality parameter for desktop
 * @param mobileQuality Quality parameter for mobile
 * @returns Enhanced URL with quality parameter
 */
export const getEnhancedSrc = (
  src: string,
  isMobile: boolean = false,
  desktopQuality: number = 95,
  mobileQuality: number = 80
): string => {
  // Split the URL into base and parameters
  const hasParams = src.includes('?');
  const baseUrl = hasParams ? src.split('?')[0] : src;
  const existingParams = hasParams ? src.split('?')[1] : '';

  // Set quality based on device type
  const qualityParam = `quality=${isMobile ? mobileQuality : desktopQuality}`;

  // Reconstruct URL with appropriate separator
  if (existingParams) {
    return `${baseUrl}?${existingParams}&${qualityParam}`;
  } else {
    return `${baseUrl}?${qualityParam}`;
  }
};
